import * as R from 'ramda';
import { CONFLICT_STATUS_CODE } from '@trs/config';
import { getErrorMessage, getErrorStatus } from '@trs/utils';
import { showBanner } from 'actions/globalActions';

export function dispatchError(error, dispatch, state) {
  let errorMessage = getErrorMessage(error);
  const status = getErrorStatus(error);

  if (state && status === CONFLICT_STATUS_CODE) {
    errorMessage = R.path(['cms', 'generic', 'data', 'CONFLICT_BANNER'], state);
  }

  dispatch(
    showBanner({
      type: 'error',
      content: errorMessage,
    })
  );
}

export default dispatchError;
